module.exports = __webpack_public_path__ + "img/xizi_lucy_wang_web_logo.9970922b.png";